const Point = require('@mapbox/point-geometry');

/**
 * Returns a Point representing a mouse event's position
 * relative to a containing element.
 *
 * @param {MouseEvent} mouseEvent
 * @param {Node} container
 * @returns {Point}
 */
function mouseEventPoint(mouseEvent, container) {
  const rect = container.getBoundingClientRect();
  return new Point(
    mouseEvent.clientX - rect.left - (container.clientLeft || 0),
    mouseEvent.clientY - rect.top - (container.clientTop || 0)
  );
}

module.exports = mouseEventPoint;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mapbox/mapbox-gl-draw/src/lib/mouse_event_point.js
// module id = nmtq
// module chunks = 0